import React, { useEffect, useState } from "react";
import {
  Typography,
  Box,
  List,
  ListItemButton,
  Divider,
  Button,
  Dialog,
  DialogContent,
  useMediaQuery,
} from "@mui/material";
import { connect } from "react-redux";
import moment from "moment";

import { homeActions } from "actions";
import SecondaryCenterTemplate from "components/SecondaryCenterTemplate";
import refillSvg from "assets/images/refil_savings_reminder_icon_active.svg";
import doseSvg from "assets/images/daily_dose_reminder_active.svg";
import doseSvgInActive from "assets/images/daily_dose_reminder_inactive.svg";
import { Delete } from "@mui/icons-material";
import { useHistory } from "react-router";

const NotificationsList = (props) => {
  const history = useHistory();
  const {
    setValue,
    getMessagesList,
    messages,
    markAsReadMessage,
    deleteMessage,
    markAllMessagesAsRead,
    deleteAllMessages,
    selectMyCoupon,
    messageDelete,
    messageRead,
    messagesMarkAllRead,
    messagesDeleteAll,
    updateGTMDataLayer,
    gtmInfo,
  } = props;
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const matches = useMediaQuery("(max-width:600px)");
  const tagManagerArgs = {
    dataLayer: gtmInfo,
    dataLayerName: "PageDataLayer",
  };
  
  useEffect(() => {
    document.getElementById("appcontent").scroll(0, 0);
    updateGTMDataLayer({
      page: "Global",
      screen: "Notifications",
      screen_title: "Global",
      event: "Nav_notification",
    });
    return () => {
      updateGTMDataLayer({
        screen_referrer: "Notifications",
        page: "Global",
        screen: "Notifications",
        screen_title: "Global",
        event: "Nav_notification",
      });
    };
  }, []);

  useEffect(() => {
    setValue(5);
  }, [setValue]);

  useEffect(() => {
    window.dataLayer.push({
      ...tagManagerArgs.dataLayer
    });
  }, [gtmInfo]);

  useEffect(() => {
    getMessagesList();
  }, [messageDelete, messageRead, messagesMarkAllRead, messagesDeleteAll]);

  const getTimeFormat = (sentDate) => {
    const d1 = moment(sentDate).fromNow();
    const times = [
      "seconds ago",
      "minute ago",
      "minutes ago",
      "hour ago",
      "hours ago",
    ];
    let today = false;
    times.forEach((x) => {
      if (d1.endsWith(x)) {
        today = true;
      }
    });
    const yesterday = d1.endsWith("a day ago")
      ? `Yesterday, ${moment(sentDate).format("hh:mm a")}`
      : moment(sentDate).format("MM/DD/YYYY, hh:mm a");
    return today ? `Today, ${moment(sentDate).format("hh:mm a")}` : yesterday;
  };

  return (
    <SecondaryCenterTemplate pageTitle="Messages">
      {messages && messages.length ? (
        <Box>
          <Box
            component="div"
            sx={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
            }}
          >
            <Button variant="outline" onClick={() => deleteAllMessages()}>
              Delete all
            </Button>
            <Button
              variant="outline"
              onClick={() => {
                markAllMessagesAsRead();
              }}
            >
              Mark all as read
            </Button>
          </Box>
          <Box my={2}>
            <Divider />
          </Box>
        </Box>
      ) : null}
      {messages && messages.length ? (
        messages.map((item) => {
          return (
            <Box key={item?.id}>
              <List>
                <ListItemButton
                  sx={{
                    paddingBottom: "1rem",
                    paddingTop: "1rem",
                    paddingLeft: matches ? 0 : undefined,
                    paddingRight: matches ? 0 : undefined,
                    cursor: item?.type === "refill" ? "pointer" : "default",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      width: "100%",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Box sx={{ display: "flex" }}>
                        <Box component="span" sx={{ verticalAlign: "middle" }}>
                          {item?.type === "refill" ? (
                            <img src={refillSvg} alt="dose" />
                          ) : (
                            <img
                              src={
                                item?.readFlag === "Y"
                                  ? doseSvgInActive
                                  : doseSvg
                              }
                              alt="dose"
                            />
                          )}
                        </Box>
                        <Box
                          component="span"
                          ml={2}
                          sx={{ display: "flex", flexDirection: "column" }}
                        >
                          <Typography
                            component="span"
                            variant="latoBlackItalic"
                            sx={{
                              fontFamily:
                                item?.readFlag === "Y" ? "Lato-Semibold" : null,
                            }}
                          >
                            {item?.title}
                          </Typography>
                        </Box>
                      </Box>
                      <Box>
                        <Typography
                          variant="h5LatoBold"
                          sx={{ color: "#607277" }}
                        >
                          {getTimeFormat(item?.sentDate)}
                        </Typography>
                      </Box>
                    </Box>
                    <Box
                      mt={1}
                      sx={{
                        paddingLeft: "38px",
                        display: "flex",
                        flexDirection: matches ? "column" : "row",
                        justifyContent: "space-between",
                        alignItems: matches ? "flex-start" : "center",
                      }}
                    >
                      <Box
                        pr={2}
                        sx={{ maxWidth: matches ? undefined : "65%" }}
                      >
                        <Box>
                          <Typography
                            mb={1}
                            component="div"
                            variant="h4LatoBold"
                          >
                            {item?.message}
                          </Typography>
                        </Box>
                        {item?.couponDetails.map((couponItem, index) => {
                          return (
                            <Typography
                              key={"couponDetails" + index}
                              onClick={() => {
                                if (item?.type === "refill") {
                                  selectMyCoupon(couponItem);
                                  history.push("/CouponDetailsView");
                                }
                              }}
                              variant="h4LatoBold"
                              sx={{
                                color: "#607277",
                                textDecoration:
                                  item?.type === "refill" ? "underline" : "",
                              }}
                            >
                              {couponItem?.dosage}, {couponItem?.name},{" "}
                              {couponItem?.strength}.
                            </Typography>
                          );
                        })}
                      </Box>
                      <Box
                        mt={matches ? 3 : undefined}
                        sx={{
                          float: matches ? undefined : "right",
                          width: matches ? "100%" : undefined,
                          display: matches ? "flex" : undefined,
                          alignItems: matches ? "center" : undefined,
                          justifyContent: matches ? "space-between" : undefined,
                        }}
                      >
                        {item?.readFlag === "Y" ? null : (
                          <Button
                            variant="outline"
                            sx={{ minWidth: "50px" }}
                            onClick={() => {
                              markAsReadMessage(item?.pushNotificationId);
                            }}
                          >
                            <Typography variant="h3LatoRegular">
                              Mark as read
                            </Typography>
                          </Button>
                        )}
                        <Box
                          component="span"
                          sx={{
                            paddingLeft: matches ? undefined : "10px",
                            cursor: "pointer",
                          }}
                        >
                          <Delete
                            sx={{ verticalAlign: "middle" }}
                            onClick={() => {
                              setShowConfirmation(true);
                              setSelectedItem(item?.pushNotificationId);
                            }}
                          />
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </ListItemButton>
                <Divider />
              </List>
            </Box>
          );
        })
      ) : (
        <Box>
          <Typography
            variant="h2LatoBlack"
            sx={{ fontSize: matches ? "18px" : "24px" }}
          >
            Welcome to your Cuverd Messages.
            {matches ? null : <br />}
            You currently do not have any.
            {matches ? null : <br />}
            You will be alerted when you receive a message.
          </Typography>
        </Box>
      )}
      {showConfirmation ? (
        <Dialog open={showConfirmation} className="app-dialog">
          <DialogContent sx={{ padding: "40px", textAlign: "center" }}>
            <Box mb={6}>
              <Typography variant="h2LatoBold">
                Are you sure you want to delete the <br /> message?
              </Typography>
            </Box>
            <Box mb={2}>
              <Button
                variant="large"
                sx={{ minWidth: matches ? "56px" : undefined }}
                onClick={() => {
                  deleteMessage(selectedItem);
                  setShowConfirmation(false);
                }}
              >
                Delete
              </Button>
            </Box>
            <Box>
              <Button
                variant="text"
                sx={{
                  minWidth: matches ? "56px" : undefined,
                  textDecoration: "underline",
                }}
                onClick={() => {
                  setShowConfirmation(false);
                }}
              >
                Cancel
              </Button>
            </Box>
          </DialogContent>
        </Dialog>
      ) : null}
    </SecondaryCenterTemplate>
  );
};

const mapStateToProps = (state) => {
  return {
    messages: state.messages.data,
    messageDelete: state.messageDelete,
    messageRead: state.messageRead,
    messagesMarkAllRead: state.messagesMarkAllRead,
    messagesDeleteAll: state.messagesDeleteAll,
    gtmInfo: state.gtmInfo.data,
  };
};

const mapDispatchToProps = {
  getMessagesList: () => homeActions.getMessagesList(),
  markAsReadMessage: (value) => homeActions.markAsReadMessage(value),
  deleteMessage: (value) => homeActions.deleteMessage(value),
  selectMyCoupon: (value) => homeActions.selectMyCoupon(value),
  markAllMessagesAsRead: () => homeActions.markAllMessagesAsRead(),
  updateGTMDataLayer: (param) => homeActions.updateGTMDataLayer(param),
  deleteAllMessages: () => homeActions.deleteAllMessages(),
};

export default connect(mapStateToProps, mapDispatchToProps)(NotificationsList);
